import { Component, ElementRef, OnInit } from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { RouteInfo } from "./sidebar.metadata";
import { Router, ActivatedRoute } from "@angular/router";
import { SidebarService } from "./sidebar.service";
import{AuthService} from '../auth/auth.service';
import { WebServiceService } from 'app/web-service.service';


declare var $: any;
@Component({
    // moduleId: module.id,
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    // host: {
    //     "(window:click)": "toggleNavbar()"
    //   }
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    authService:any;
    emp:string;
    totalCredit: any;
    utilise: any;
    balance: any;
    mainmenu: any;
    submenu: any;
    mainrouter: any;
    staticRoutes: any;
    subroutes: any;
    getScreenWidth: any;
    constructor(private router: Router,
        private route: ActivatedRoute,
        private sidebarService: SidebarService,authService:AuthService,public service:WebServiceService,private ElByClassName: ElementRef) {
            this.authService=authService;
            this.emp=JSON.parse(sessionStorage.getItem("currentUser")).firstname;
      
    }

    ngOnInit() {
        $.getScript('./assets/app/js/core/app-menu.js');
        $.getScript('./assets/app/js/core/app.js');
        $.getScript('./assets/js/scripts.min.js');
    //    this.menuItems = ROUTES.filter(menuItem => menuItem);
    //    this.sidebarService.geMenus()
    // this.service.httpGet("userMenus?userId="+JSON.parse(sessionStorage.getItem("currentUser")).user_id)
    //    .subscribe((data:any) =>{ 
    //     this.menuItems = data.data;
    // }  );
       
    this.sidebarService.geMenus().subscribe((data:any) =>{
        this.menuItems = data.data
        sessionStorage.setItem('menu',JSON.stringify(data.data))
        for(let i=0;i<this.menuItems.length;i++){
        
        this.menuItems[i].class=this.menuItems[i].icon.split('.')[0];
       
            this.menuItems[i].icon='rutwa rutwa-'+this.menuItems[i].class;
        
        }
        });
        $(document).click(function(e) {
            $(".sub").removeClass("show");
        });
    }
    toggleNavbar(tagId){
    // $('.menu-toggle').addClass('menu-hide');
    // $('.menu-hide').addClass('menu-open');
    $('#'+tagId).removeClass('show');
    // console.log(el)
    console.log("toggle");
    this.getScreenWidth = document.documentElement.clientWidth;
    if(this.getScreenWidth < 992)
    $("body").toggleClass("left-sidebar-hidden")
}

logout(){
    console.log("method called");
    this.authService.logout();
    this.router.navigate(['login']);
}
changepwd(){
    this.router.navigate(['change-pwd']);
}
creditDetails()
    {
      this.service.httpGet('get/credit/'+JSON.parse(sessionStorage.getItem("currentUser")).agencyId).subscribe((data:any)=>{
            this.balance=data.data.balance
            this.utilise=data.data.utilized
            this.totalCredit=data.data.totalCredit
      })
    }
    menuclose(){
        $('.menu-open').removeClass('menu-open');
    }
   

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts